// The mailbox's app password (the one a mail app uses for IMAP and SMTP).
//
// POST .../fdts/ replaces it: every mail app using the old one stops working.
// The page used POST just to show it, so looking at the password signed out
// every phone and desktop client. The api adds GET .../fdts/, which reads the
// current one without changing it (NM-API-15). Until that is deployed the
// api answers GET with 405, and only then does showing fall back to POST,
// which is what the page always did; `rotated` says which happened.
//
// A mailbox with more than one token is locked out: smtp and mx refuse every
// password for it. The api's GET says so with 409 and "Generate a new
// password to fix it", and only a POST repairs it (it deletes every token
// and makes one). Showing must not do that on its own, so the outcome says
// `needsNewPassword` and the page offers "Generate new password" for the
// person to press: before, it offered only "Show password" again, which
// asked the same GET and got the same 409.
//
// `request(method)` performs the call and resolves to a fetch Response.
import { jsonBody } from './api-errors.js';

const NOT_ALLOWED = 405;
const SEVERAL_TOKENS = 409;

const outcome = async (res, rotated) => ({
  ok: res.ok,
  status: res.status,
  body: await jsonBody(res),
  rotated: res.ok && rotated,
  needsNewPassword: !rotated && res.status === SEVERAL_TOKENS,
});

export const revealAppPassword = async (request) => {
  const shown = await request('GET');
  if (shown.status !== NOT_ALLOWED) return outcome(shown, false);
  return outcome(await request('POST'), true);
};

export const rotateAppPassword = async (request) => outcome(await request('POST'), true);
